import request from '@/utils/request'

export function index(apiName, data) {
  
  return request({
    url: apiName,
    method: 'get',
    params: data
  })
}

export function read(apiName, data) {
  
  return request({
    url: apiName + '/' + data.id,
    method: 'get',
    params: data
  })
}

export function save(apiName, data) {
  
  return request({
    url: apiName,
    method: 'post',
    data: data
  })
}

export function update(apiName, data) {
  
  return request({
    url: apiName + '/' + data.id,
    method: 'put',
    data: data
  })
}

export function del(apiName, data) {
  
  return request({
    url: apiName + '/' + data.id,
    method: 'delete'
  })
}

